import { Create, SimpleForm, TextInput, email, required } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';

export const AdminCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="admins" />}>
      <MyFormContainer>
        <TextInput source="full_name" validate={required()} />
        <TextInput source="email" type="email" validate={[required(), email()]} />
        <TextInput
          source="password"
          type="password"
          validate={required()}
          autoComplete="new-password"
        />
        <TextInput source="contact_no" />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default AdminCreate;
